//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CircularButton from '@/components/Shared/CircularButton.vue'
export default {
  components: {
    CircularButton,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClose)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClose)
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    handleClose(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    handleClickItem(eventName) {
      this.toggleDropdown()
      this.$emit(eventName)
    },
  },
}
